"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getAutoHeightDuration = function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }

  var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

  return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
};

var _default = getAutoHeightDuration;
exports["default"] = _default;